import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b34f128"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Whale Eco user agent")
const _hoisted_3 = { class: "flex_align_center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Custom user agent ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 1920*1080 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 1280*720 ")
const _hoisted_7 = { class: "flex_end footer_btn" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Ok ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Default ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex_between footer_btn" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Ok ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Default ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Cancel ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_Mappingkey = _resolveComponent("Mappingkey")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_tabs, {
        activeKey: _ctx.activeKey,
        "onUpdate:activeKey": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activeKey) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_tab_pane, {
            key: "1",
            tab: "User Agent"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                class: "user_agent",
                value: _ctx.settingData.agent,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settingData.agent) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_a_radio, {
                      style: {"margin-bottom":"0"},
                      value: 1
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", {
                      class: "edit",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openAgentEditor && _ctx.openAgentEditor(...args)), ["stop"]))
                    }, " Edit ")
                  ])
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "2",
            tab: "Resolution"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                label: "Resolution",
                "wrapper-col": { span: 8, offset: 0 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.settingData.resolution,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settingData.resolution) = $event)),
                    "default-value": 2,
                    style: {"width":"1.6rem"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "1920*1080" }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "1280*720" }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "3",
            tab: "Proxy",
            forceRender: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                class: "add_book_marks",
                rules: _ctx.rules,
                ref: "ipPort",
                model: _ctx.settingData,
                "label-col": _ctx.labelCol,
                labelAlign: "left",
                "wrapper-col": _ctx.wrapperCol
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Proxy",
                    class: "proxy"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_switch, {
                        checked: _ctx.switchValue,
                        "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.switchValue) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "IP Address",
                    name: "ip",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.settingData.ip,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.settingData.ip) = $event)),
                        help: "helphep",
                        placeholder: "Please input IP Address",
                        disabled: _ctx.isDisabled
                      }, null, 8, ["value", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "Port",
                    name: "port",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.settingData.port,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.settingData.port) = $event)),
                        placeholder: "Please input Port",
                        disabled: _ctx.isDisabled
                      }, null, 8, ["value", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["rules", "model", "label-col", "wrapper-col"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "4",
            tab: "Mappings Keys",
            class: "tabs_pdlr",
            forceRender: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Mappingkey, { ref: "mapKey" }, null, 512)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["activeKey"]),
      _createVNode(_component_a_form_item, { "wrapper-col": { span: 24, offset: 0 } }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.onSave
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.activeKey === '4')
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  onClick: _ctx.setKeyMapDefault
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_modal, {
      width: "3.9rem",
      visible: _ctx.userAgentEditorShow,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userAgentEditorShow) = $event)),
      footer: null,
      closable: false,
      class: "editor_modal",
      title: "User agent editor"
    }, {
      default: _withCtx(() => [
        (_ctx.userAgentEditorShow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_a_textarea, {
                value: _ctx.userurl,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userurl) = $event)),
                class: "editor_textarea",
                "auto-size": { minRows: 5, maxRows: 5 }
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.saveAgentUrl
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, { onClick: _ctx.setAgentDefault }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, { onClick: _ctx.closeAgentEditor }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}